import { Box, Button, Grid } from '@mui/material'
import React, { useEffect, useState } from 'react'
import EmptyTableRow from 'src/Component/EmptyTableRow'
import PaginatedTable, { HeadCellI, SortOrderI } from 'src/Component/PaginatedTable'
import DataRow from './DataRow'
import { useDispatch } from 'react-redux'
import { AppDispatch } from 'src/store'
import { startPageLoader, stopPageLoader } from 'src/store/features/common/commonSlice'

import SearchInput from 'src/Component/SearchInput'

import TabComponent from 'src/Component/TabComponent'
import { PRODUCT_TYPES } from 'src/utils/constants'
import { useGetProductsTransactionByTypeQuery } from 'src/api/manageProductsApi'
import { TransactionI } from 'src/api/manageProductsApi/types'
import ViewSaleReportsDetailsModal from './ViewSalesReportDetailsModal'

const headCells: HeadCellI[] = [
  {
    id: 'id',
    sortable: true,
    label: 'Transaction ID',
  },
  {
    id: 'amount_payable',
    sortable: true,
    label: 'Amount',
  },
  {
    id: 'status',
    sortable: true,
    label: 'Status',
  },

  {
    id: 'created_at',
    sortable: true,
    label: 'Payment Date',
  },

  {
    id: 'id',
    sortable: false,
    label: 'Actions',
    align: 'center',
  },
]

const SaleReports = () => {
  // states
  const [activeTabIndex, setActiveTabIndex] = useState<number>(0)
  const [page, setPage] = useState<number>(1)
  const [sortOrder, setSortOrder] = useState<SortOrderI>('asc')
  const [sortOrderBy, setSortOrderBy] = useState<string>('') // headCells[i].id

  const [openAddNewModal, setOpenAddNewModal] = useState(false)
  const [SaleReportsDetailsModal, setSaleReportsDetailsModal] = useState({
    transaction: {} as TransactionI,
    open: false,
  })

  const [search, setSearch] = useState<string>('')

  // hooks
  const {
    data: TRANSACTION_RESPONSE,
    isFetching,
    refetch,
  } = useGetProductsTransactionByTypeQuery(
    {
      type: PRODUCT_TYPES[activeTabIndex],
      search,
      page,
      pageSize: 10,
      sortBy: (() => {
        if (sortOrder === 'asc') {
          return sortOrderBy
        } else {
          return `-${sortOrderBy}`
        }
      })(),
    },
    { refetchOnMountOrArgChange: true },
  )
  const dispatch = useDispatch<AppDispatch>()

  // functions
  const handlePageChange = (page: number) => {
    setPage(page)
  }

  const handleSorting = (_sortOrderBy: string) => {
    setSortOrder((prevState) => {
      return prevState === 'asc' ? 'desc' : 'asc'
    })
    setSortOrderBy(_sortOrderBy)
  }

  const handleViewDetailClick = (transaction: TransactionI) => {
    setSaleReportsDetailsModal({
      transaction: transaction,
      open: true,
    })
  }
  const handleSaleReportsDetailsModalClose = () => {
    setSaleReportsDetailsModal({
      transaction: {} as TransactionI,
      open: false,
    })
  }

  const handleSearch = (value: string) => {
    setPage(1)
    setSearch(value)
  }

  const handleTabChange = (tabIndex: number) => {
    setActiveTabIndex(tabIndex)
    setPage(1)
    setSearch('')
  }

  // use effects
  useEffect(() => {
    if (isFetching) {
      dispatch(startPageLoader())
    } else {
      dispatch(stopPageLoader())
    }
  }, [isFetching])

  return (
    <Box className='pageContainer'>
      <Grid container>
        <Grid md={8} sm={12} xs={12}>
          {' '}
        </Grid>
        <Grid md={4} sm={12} xs={12}>
          <Box>
            <SearchInput hasDebounce onChange={handleSearch} value={search} />
          </Box>
        </Grid>
      </Grid>

      <Grid mt={10} container justifyContent='space-between'>
        <Grid item>
          {' '}
          <TabComponent
            options={PRODUCT_TYPES}
            activeIndex={activeTabIndex}
            onTabIndexChange={handleTabChange}
          />{' '}
        </Grid>
      </Grid>

      <Box mt={2}>
        {TRANSACTION_RESPONSE && (
          <PaginatedTable
            title={PRODUCT_TYPES[activeTabIndex]}
            headCells={headCells}
            currentPage={page}
            onPageChange={handlePageChange}
            totalPages={Math.ceil(TRANSACTION_RESPONSE?.count / 10)}
            onSortClick={handleSorting}
          >
            <>
              {TRANSACTION_RESPONSE?.results?.length === 0 && (
                <EmptyTableRow cellCount={headCells.length} />
              )}
              {TRANSACTION_RESPONSE?.results?.map((transaction) => {
                return (
                  <DataRow
                    key={transaction.id}
                    transaction={transaction}
                    onViewDetailsClick={handleViewDetailClick}
                  />
                )
              })}
            </>
          </PaginatedTable>
        )}
      </Box>

      {!!SaleReportsDetailsModal.transaction && (
        <ViewSaleReportsDetailsModal
          transaction={SaleReportsDetailsModal.transaction}
          open={SaleReportsDetailsModal.open}
          onClose={handleSaleReportsDetailsModalClose}
        />
      )}
    </Box>
  )
}

export default SaleReports
